/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'edit': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<path pid="0" d="M8.706 2.36l2.848 2.847-7.21 7.209-2.846-2.848L8.706 2.36zm5.008-.688l-1.27-1.27a1.26 1.26 0 00-1.78 0L9.447 1.62l2.848 2.848 1.42-1.42a.97.97 0 000-1.375zM.008 13.571a.324.324 0 00.392.386l3.173-.77L.728 10.34l-.72 3.232z" _fill="#6D9AE8"/>'
  }
})
